'use client';

import React, { createContext } from 'react';
/** @public */
export const ContentfulContext = createContext({});
/** @public */
const ContentfulProvider = ({
  contentful,
  children
}) => {
  return React.createElement(ContentfulContext.Provider, {
    value: contentful
  }, children);
};
ContentfulProvider.displayName = 'ContentfulProvider';
ContentfulContext.displayName = 'ContentfulContext';
export default ContentfulProvider;